// extracted by mini-css-extract-plugin
export default {"WhySubaru":"hJSIc0WFun"};